import type { TFunction } from "i18next";

import { DATE_WITH_TIME_FORMAT, SHORT_DATE_FORMAT } from "shared/constants";
import { formatDate } from "shared/locale/format";

import { FilterDiffData, FilterOperator } from "features/ui/Filters/types";
import { getDateUnitOptions, isDateTimeField } from "features/ui/Filters/utils";
import { SchemaEntry } from "features/ui/MaterialTable";

interface GetDateFilterLabelProps {
  t: TFunction;
  schemaEntry?: SchemaEntry;
  values: string[];
  operator: FilterOperator;
  applyValueDiffStyle: boolean;
  diff?: FilterDiffData;
}

export const getDateFilterLabel = ({
  t,
  schemaEntry,
  values,
  operator,
  applyValueDiffStyle,
  diff,
}: GetDateFilterLabelProps) => {
  const useTimeFormat = isDateTimeField(schemaEntry?.filter?.filterDataType);
  const hasTimeInString = values[0].includes("T");

  const format =
    useTimeFormat && hasTimeInString
      ? DATE_WITH_TIME_FORMAT
      : SHORT_DATE_FORMAT;

  let defaultLabel = formatDate(values[0], format, !useTimeFormat);

  if (values.length === 2 && operator === FilterOperator.BETWEEN) {
    const valDate1 = formatDate(values[0], format, !useTimeFormat);
    const valDate2 = formatDate(values[1], format, !useTimeFormat);
    defaultLabel = `${valDate1 || t("any")} - ${valDate2 || t("any")}`;
  }

  return (
    <span className={applyValueDiffStyle ? diff?.bgColor : undefined}>
      {defaultLabel}
    </span>
  );
};

interface GetLastDateFilterLabelProps {
  t: TFunction;
  values: string[];
  applyValueDiffStyle: boolean;
  diff?: FilterDiffData;
}

export const getLastDateFilterLabel = ({
  t,
  values,
  applyValueDiffStyle,
  diff,
}: GetLastDateFilterLabelProps) => {
  const value = values[0].slice(0, -1);
  const periodCharacter = values[0].slice(-1);

  const period = getDateUnitOptions(t).find(
    ({ id }) => id === periodCharacter
  )?.value;

  return (
    <span className={applyValueDiffStyle ? diff?.bgColor : undefined}>
      {value} {period}
    </span>
  );
};
